class ExtendSectionT3Muse extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    // _safeInit(() => this.initPressQuote());
    // // 滚动驱动
    // this._scrollEffects = [
    //   _safeInit(() => this.initComparison()),
    // ].filter(Boolean);
    // // 尺寸变化驱动
    // this._resizeEffects = [
    //   _safeInit(() => this.initRecordingWorkflow()),
    // ].filter(Boolean);
    // if (!!this._scrollEffects) {
    //   this._scrollEffects.forEach((fn) => fn());
    // }
  }

  onScroll() {
    if (!!this._scrollEffects) {
      this._scrollEffects.forEach((fn) => fn());
    }
  }

  onResize() {
    super.onResize(); // 执行基类 _resizeFlktyListAll()
    if (!!this._resizeEffects) {
      this._resizeEffects.forEach((fn) => fn());
    }
  }
}
